import { render, staticRenderFns } from "./FixedFieldsNotice.vue?vue&type=template&id=480e671c&scoped=true"
import script from "./FixedFieldsNotice.vue?vue&type=script&lang=js"
export * from "./FixedFieldsNotice.vue?vue&type=script&lang=js"
import style0 from "./FixedFieldsNotice.vue?vue&type=style&index=0&id=480e671c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e671c",
  null
  
)

export default component.exports